import React, { useState, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../assets/Logo For Website 01.png';
import { Divide as Hamburger } from 'hamburger-react';


const Header = () => {
    const location = useLocation();
    const [isOpen, setOpen] = useState(false);


    const menuItems = useMemo(() => [
        { to: "/cenik", text: "Ceník", isExternal: false },
        { to: "/o-mne", text: "O mně", isExternal: false },
        { to: "https://urbanfyzio.reservio.com/", text: "Rezervace", isExternal: true, isCta: true },
    ], []);


    const closeMenu = () => {
        setOpen(false);
    };

    const NavLink = ({ to, text, isExternal, isCta }) => {
        if (isCta) {
            return (
                <a
                    href={to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ml-2 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-brand-500 text-white text-sm font-semibold shadow-brand-glow hover:bg-brand-600 hover:-translate-y-0.5 transition-all duration-200 ease-smooth"
                >
                    {text}
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                </a>
            );
        }
        if (isExternal) {
            return (
                <a
                    href={to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 rounded-lg text-sm font-medium text-ink-700 hover:text-brand-700 hover:bg-brand-50 transition-colors duration-200"
                >
                    {text}
                </a>
            );
        }

        const isActive = location.pathname.startsWith(to);
        return (
            <Link
                to={to}
                className={`relative px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    isActive
                        ? 'text-brand-700 bg-brand-50'
                        : 'text-ink-700 hover:text-brand-700 hover:bg-brand-50'
                }`}
            >
                {text}
                {isActive && (
                    <span className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-6 h-0.5 rounded-full bg-brand-500" />
                )}
            </Link>
        );
    };


    return (
        <nav className="bg-white/90 backdrop-blur-md sticky top-0 z-20 border-b border-ink-100 shadow-soft">
            <div className="container-narrow section">
                <div className="relative flex h-16 md:h-20 items-center justify-between">
                    <Link to="/" onClick={closeMenu} className="flex items-center">
                        <img src={Logo} alt="UrbanFyzio Logo" className="h-9 md:h-11 w-auto" />
                    </Link>
                    <div className="flex items-center">
                        {/* Desktop menu items */}
                        <div className="hidden sm:flex sm:items-center sm:gap-1">
                            {menuItems.map(item => (
                                <NavLink key={item.to} {...item} />
                            ))}
                        </div>

                        {/* Mobile hamburger menu */}
                        <div className="sm:hidden ml-2 text-ink-800">
                            <Hamburger
                                toggled={isOpen}
                                toggle={setOpen}
                                size={22}
                                aria-controls="mobile-menu"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile menu */}
            {isOpen && (
                <div className="sm:hidden absolute top-full left-0 right-0 border-t border-ink-100 bg-white shadow-soft-lg" id="mobile-menu">
                    <div className="space-y-1 px-4 py-3">
                        {menuItems
                            .filter(item => !(location.pathname.startsWith('/cenik') && item.isCta))
                            .map(item => (
                            item.isExternal ? (
                                <a
                                    key={item.text}
                                    href={item.to}
                                    onClick={closeMenu}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={
                                        item.isCta
                                            ? "block text-center mt-2 px-4 py-3 rounded-full bg-brand-500 text-white font-semibold shadow-brand-glow"
                                            : "block px-4 py-3 rounded-lg text-base font-medium text-ink-700 hover:bg-brand-50 hover:text-brand-700"
                                    }
                                >
                                    {item.text}
                                </a>
                            ) : (
                                <Link
                                    key={item.to}
                                    to={item.to}
                                    onClick={closeMenu}
                                    className={`block px-4 py-3 rounded-lg text-base font-medium ${
                                        location.pathname.startsWith(item.to)
                                            ? 'bg-brand-50 text-brand-700'
                                            : 'text-ink-700 hover:bg-brand-50 hover:text-brand-700'
                                    }`}
                                >
                                    {item.text}
                                </Link>
                            )
                        ))}
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Header;
